<template>
    <div class="login-body">
        <div class="page-container">
                <welcomePage v-if="page == 'welcome'" class="page welcome-page" @nextPage="changePage" key="1" />
                <phonePage v-else-if="page == 'phone'" class="page phone-page" @phone="handlePhone" @nextPage="changePage" key="2" />
                <verifyPage v-else class="page verify-page" :phone="phone" key="3"/>
        </div>
    </div>
</template>

<script>
import welcomePage from '@/components/login/welcomePage.vue';
import phonePage from '@/components/login/phonePage.vue';
import verifyPage from '@/components/login/verifyPage.vue';

import axios from 'axios';


export default {
    name: 'LoginView',
    async beforeMount() {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await axios.post('https://api.noticapp.ir/v1/auth/me/', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data.status && response.data.status === 'error') {
                    localStorage.removeItem('token');
                }
                else {
                    this.$router.push({ name: 'home' });
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem('token');
                }
                else {
                    console.error('خطای ناشناخته رخ داده است: ', error);
                }
            }
        }
    },
    data() {
        return {
            phone: "",
            page: 'welcome'
        };
    },
    methods: {
        changePage (page) {
            this.page = page
        },
        handlePhone(phone) {
            if (phone) {
                this.phone = phone;
            }
        }
    },
    mounted() {

        
    },
    components: {
        welcomePage,
        phonePage,
        verifyPage
    }
}
</script>

<style>
    .login-body {
        background-color: #25292E;
        height: 100vh;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 75px;
    }
</style>